import { z } from "zod";

import type { GetProductQuery, GetProductsQuery } from "./gqls";

export type ProductListRaw = GetProductsQuery["products"][number];
export type ProductDetailRaw = NonNullable<GetProductQuery["productsByPk"]>;

export interface ProductRow {
  id: string;
  name: string;
  originHosts: string;
  isDeactivated: boolean;
}

export interface ProductDetailUI {
  id: string;
  name: string;
  originHosts: string;
  importDirectWebhookUrl: string | null;
  availableRoles: string[];
  availableRoleIds: string[];
  createdAt: string;
  updatedAt: string;
  deactivatedAt: string | null;
}

export const zProductFormData = z.object({
  name: z.string(),
  originHosts: z.string(),
  importDirectWebhookUrl: z.string().optional(),
  availableRoleIds: z.array(z.string()),
});

export type ProductFormData = z.infer<typeof zProductFormData>;
export const zProductFormDataKeys = zProductFormData.keyof();

export const zProductEditFormData = zProductFormData.extend({
  id: z.string(),
});

export type ProductEditFormData = z.infer<typeof zProductEditFormData>;
export const zProductEditFormDataKeys = zProductEditFormData.keyof();
